<template>
  <Row type="none" class="bg-white rounded shadow min-h-screen">

      <div class="container py-4">
          <b-button
              variant="primary"
              id="order"
              @click="make"
          >
              {{ $t('productPriceModify.newDocument') }}
          </b-button>
      </div>

      <ProductModifyListTable />

      <RowColumn class="mt-4">
          <Pagination
              class="ml-4"
              :search="search"
              base-url="product-modify"
              :total-items="getModifiedProductsTotalCount"
              method-name="fetchModifyProducts"/>
      </RowColumn>
  </Row>
</template>

<script>
import RowColumn from "@/components/RowColumn.vue";
import Pagination from "@/components/html/Pagination.vue";
import {mapActions, mapGetters} from "vuex";
import ProductModifyListTable from "@/components/ProductModifyListTable.vue";
import Row from "@/components/html/Row.vue";

export default {
    name: "priceModifyList",
    components: {Row, ProductModifyListTable, Pagination, RowColumn},
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'productPriceModify.title'},
            ],
            inventoryId: null,
            search: {
                page: 1
            }
        }
    },
    computed: {
        ...mapGetters(['getModifiedProducts', 'getModifiedProductsTotalCount', 'getModifyProduct'])
    },
    methods: {
        ...mapActions(['fetchModifyProducts', 'fetchModifyProduct', 'setModifyProductDetails', 'setBreadcrumbItems']),
        make() {
            this.$i18nHelper.toUrl('product-modify-make')
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>

</style>
